import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PdaComponent } from './pda.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PdaRoutingModule } from './pda-routing.module';



@NgModule({
  declarations: [
    PdaComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    PdaRoutingModule
  ]
})
export class PdaModule { }
